import axios from 'axios';

import { MerchantOffer } from './types';

export const woltCapitalAPI = axios.create({
  baseURL: process.env.WOLT_CAPITAL_API_URI,
});

export const getOfferByMerchantID = (merchantId: string): Promise<MerchantOffer> =>
  woltCapitalAPI.get(`/public/api/v1/merchants/${merchantId}/offer`).then(response => response.data);

export default woltCapitalAPI;
